// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
// Others
import { IFormIncident } from '~/utils/interface/incident';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): yup.ObjectSchema<IFormIncident> => {
  return yup.object().shape({
    type: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    priority: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    jobId: yup.string().trim().optional(),
    description: yup.string().trim().optional(),
  });
};

export const defaultValuesIncidentForm: IFormIncident = {
  jobId: EMPTY_STRING,
  type: EMPTY_STRING,
  priority: EMPTY_STRING,
};
